import { createSlice  } from "@reduxjs/toolkit";

const initialState = {
    items: [],
	totalAmount: 0,
	totalQuantity: 0
};


const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        add(state, action){
            let itemExists = false;
            state.items.some((item) => {
                if(item.ID === action.payload.ID){
                    itemExists = true;
                }

                return itemExists;
            });
            if(!itemExists){
				const newItem=action.payload;
				console.log(action.payload);
				state.totalQuantity++;
				state.totalAmount=state.totalAmount + newItem.DTCPrice;
				let AAOEflag = (newItem.AAOE === 1) ? "1": "";
				let AAOEA = newItem.aaoeanswers 
				state.items.push({
					ID: newItem.ID,
					DTCPrice: newItem.DTCPrice,
					TestId: newItem.TestId,
					TestName: newItem.TestName,
					AAOE: AAOEflag,
					AAOEAnswers: AAOEA,
					Required: newItem.required,
				});
            }
        },
        remove(state, action) {
		  const id = action.payload;
		  const existingItem = state.items.find((item) => item.TestId === id);
		  state.totalQuantity--;
		  state.totalAmount=state.totalAmount - existingItem.DTCPrice;
		  //state.changed = true;
		  state.items = state.items.filter((item) => item.TestId !== id);
		},
        view(state){

        },
		emptyCart(state){
			console.log("emptying cart");
			return initialState;
		},
		addAAOE(state, action){
			console.log("updating AAOE");
			const aaoeplus=action.payload;
			console.log(aaoeplus);
			const id=action.payload.id
			const itemIndex = state.items.findIndex((item) => item.TestId === id);
			console.log(itemIndex);
			if (itemIndex !== -1) {
				console.log('found item',itemIndex);
				let aaoe=aaoeplus.aaoeanswers;
				console.log("aaoe",aaoe);
				const newArray = [...state.items];
				newArray[itemIndex].AAOEAnswers = aaoe;
				console.log("updated aaoe");
				state.items=newArray;
				//return {...state, items: newArray,}
			}
			
		}
	}
});

export const cartActions = cartSlice.actions;
export default cartSlice.reducer;
